import React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import SettingsIcon from '@material-ui/icons/Settings';
import LogoutButton from './LogoutButton';
import { makeFriendlyTitleFromPath } from '../components/common/TitleHelper'
import { useLocation } from 'react-router-dom';


const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
        },
        menuButton: {
            marginRight: theme.spacing(2),
        },
        title: {
            flexGrow: 1,
            textAlign: 'center'
        },
    }),
);

export default function ButtonAppBar() {
    const classes = useStyles();
    const pathname = useLocation().pathname;
    let friendlyPath = makeFriendlyTitleFromPath(pathname)


    return (
        <div className={classes.root}>
            <AppBar position="static">
                <Toolbar>
                    <Typography variant="h6" noWrap className={classes.title}>
                        <span className="page-title">
                            {friendlyPath}
                        </span>
                    </Typography>
                    <LogoutButton />
                </Toolbar>
            </AppBar>
        </div>
    );
}



